export default [
  {
    path: '/guahaojilu',
    name: 'guahaojilu',
    meta: { title: '挂号记录', keepAlive: true },
    component: () => import(/* webpackChunkName: "guahao" */ '../views/yuyueguahao/guahaojilu')
  },
  {
    path: '/yuyueguahao',
    name: 'yuyueguahao',
    meta: { title: '科室列表', keepAlive: false },
    component: () => import(/* webpackChunkName: "guahao" */ '../views/yuyueguahao/yuyueguahao')
  },
  {
    path: '/registered',
    name: 'registered',
    meta: { title: '预约挂号', keepAlive: true },
    component: () => import(/* webpackChunkName: "guahao" */ '../views/yuyueguahao/registered')
  },
  {
    path: '/registeredDetails',
    name: 'registeredDetails',
    meta: { title: '预约挂号', keepAlive: true },
    component: () => import(/* webpackChunkName: "guahao" */ '../views/yuyueguahao/registeredDetails')
  },
  {
    path: '/guahaoqueren',
    name: 'guahaoqueren',
    meta: { title: '挂号确认' },
    component: () => import(/* webpackChunkName: "guahao" */ '../views/yuyueguahao/guahaoqueren')
  },
  {
    path: '/guahaoxiangqing',
    name: 'guahaoxiangqing',
    meta: { title: '挂号详情' },
    component: () => import(/* webpackChunkName: "guahao" */ '../views/yuyueguahao/guahaoxiangqing')
  },
  {
    path: '/guahaofangshi',
    name: 'guahaofangshi',
    meta: { title: '挂号选择' },
    component: () => import(/* webpackChunkName: "guahao" */ '../views/yuyueguahao/guahaofangshi')
  },
  {
    path: '/xuanzeyisheng',
    name: 'xuanzeyisheng',
    meta: { title: '挂号选择' },
    component: () => import(/* webpackChunkName: "guahao" */ '../views/yuyueguahao/xuanzeyisheng')
  },
  {
    path: '/yishengliebiao',
    name: 'yishengliebiao',
    meta: { title: '预约挂号' },
    component: () => import(/* webpackChunkName: "guahao" */ '../views/yuyueguahao/yishengliebiao')
  },
  {
    path: '/zhuanjiaguahao',
    name: 'zhuanjiaguahao',
    meta: { title: '专家挂号' },
    component: () => import(/* webpackChunkName: "guahao" */ '../views/yuyueguahao/zhuanjiaguahao')
  },
  {
    path: '/yishengpaiban',
    name: 'yishengpaiban',
    meta: { title: '专家挂号' },
    component: () => import(/* webpackChunkName: "guahao" */ '../views/yuyueguahao/yishengpaiban')
  },
  {
    path: '/yuanquxuanze',
    name: 'yuanquxuanze',
    meta: { title: '院区选择' },
    component: () => import(/* webpackChunkName: "guahao" */ '../views/yuyueguahao/yuanquxuanze')
  },
  {
    path: '/fuzhen',
    name: 'fuzhen',
    meta: { title: '复诊' },
    component: () => import(/* webpackChunkName: "guahao" */ '../views/fuzhen/fuzhen')
  }
]
